import styles from "./BlogPost.module.css";

export default function Header({ children }) {
  return (
    <div
      className={`flex justify-center w-full min-h-[150px] py-12 md:min-h-[180px] md:py-14
      bg-altblue-600 ${styles.cont}`}
    >
      <div className="w-full max-w-4xl px-6 md:px-8">{children}</div>
    </div>
  );
}
